import { getProjectBySlug } from '../../../../data/projects';
import { CaseStudyPage } from '../../../../components/caseStudy';

const project = getProjectBySlug('dojaka');

const DojakaPage = () => <CaseStudyPage project={project} />;

export default DojakaPage;
